﻿export const STYLE_TYPE_WEBGL = 'webgl';
export const STYLE_TYPE_CANVAS = 'canvas';
export const STYLE_TYPE_HEATMAP = 'heatmap';
export const STYLE_TYPE_THEMATIC = 'thematic';

export const DEFAULT_STYLE_TYPE = 0;
export const HOVER_STYLE_TYPE = 1;
export const SELECT_STYLE_TYPE = 2;
export const EDIT_STYLE_TYPE = 3;

export const POINT = 'Sld.RuleSymbolizerPointSymbolizer, XPortal4.Core';
export const LINE = 'Sld.RuleSymbolizerLineSymbolizer, XPortal4.Core';
export const POLYGON = 'Sld.RuleSymbolizerPolygonSymbolizer, XPortal4.Core';
export const LABEL = 'Sld.RuleSymbolizerTextSymbolizer, XPortal4.Core';

export const WKN_CIRCLE = 'circle';
export const WKN_SQUARE = 'square';
export const WKN_TRIANGLE = 'triangle';
export const WKN_STAR = 'star';
export const WKN_CROSS = 'cross';
export const WKN_X = 'x';

export const FILTER_COMPARISON_GREATER_THAN = '>';
export const FILTER_COMPARISON_GREATER_THAN_OPERATOR = 'propertyisgreaterthan';
export const FILTER_COMPARISON_GREATER_THAN_OR_EQUAL = '>=';
export const FILTER_COMPARISON_GREATER_THAN_OR_EQUAL_OPERATOR = 'propertyisgreaterthanorequalto';
export const FILTER_COMPARISON_LOWER_THAN = '<';
export const FILTER_COMPARISON_LOWER_THAN_OPERATOR = 'propertyislessthan';
export const FILTER_COMPARISON_LOWER_THAN_OR_EQUAL = '<=';
export const FILTER_COMPARISON_LOWER_THAN_OR_EQUAL_OPERATOR = 'propertyislessthanorequalto';
export const FILTER_COMPARISON_EQUAL = '=';
export const FILTER_COMPARISON_EQUAL_OPERATOR = 'propertyisequalto';
export const FILTER_COMPARISON_NOT_EQUAL = '!=';
export const FILTER_COMPARISON_NOT_EQUAL_OPERATOR = 'propertyisnotequalto';
export const FILTER_COMPARISON_BETWEEN = 'BETWEEN';
export const FILTER_COMPARISON_BETWEEN_OPERATOR = 'propertyisbetween';
export const FILTER_COMPARISON_LIKE = 'LIKE';
export const FILTER_COMPARISON_LIKE_OPERATOR = 'propertyislike';
export const FILTER_COMPARISON_IS_NULL = 'IS';
export const FILTER_COMPARISON_IS_NULL_OPERATOR = 'propertyisnull';

export const SYSTEM_STYLE_GEOLOCATION = 0;
export const SYSTEM_STYLE_POINT = 1;
export const SYSTEM_STYLE_LINE = 2;
export const SYSTEM_STYLE_POLYGON = 3;
export const SYSTEM_STYLE_ALL = 4;
export const SYSTEM_STYLE_EDIT_POINT = 5;
export const SYSTEM_STYLE_EDIT_LINE = 6;
export const SYSTEM_STYLE_EDIT_POLYGON = 7;
export const SYSTEM_STYLE_EDIT_ALL = 8;
export const SYSTEM_STYLE_DWG = 9;
export const SYSTEM_STYLE_SHAPE = 10;